import { Landmark, Shield, TrendingUp, Repeat, Scroll, GraduationCap } from 'lucide-react';
import { SERVICES } from '@/lib/brand';
import Reveal from '@/components/Reveal';

const ICONS = {
  'landmark': Landmark,
  'shield': Shield,
  'trending-up': TrendingUp,
  'repeat': Repeat,
  'scroll': Scroll,
  'graduation-cap': GraduationCap,
};

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-[#F7F4EE] py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 mb-20 items-end">
          <div className="lg:col-span-2">
            <Reveal>
              <div className="overline text-[#B68A35] mb-6">Our Services</div>
            </Reveal>
            <Reveal delay={120}>
              <h2 className="font-serif text-[#0E2238] text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
                Strategies Designed for<br />
                <span className="italic">Every Season</span>.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={280}>
            <p className="text-[#2B2B2B]/70 text-base md:text-lg font-light leading-[1.7]">
              From protection today to preservation tomorrow — a curated set of insurance based
              and retirement strategies tailored to your goals.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <Reveal key={s.title} delay={(i % 3) * 100}>
                <div
                  data-testid={`service-card-${s.title.toLowerCase().replace(/\s|&/g, '-')}`}
                  className="card-cream p-8 md:p-10 relative group flex flex-col h-full"
                >
                  <div className="w-12 h-12 rounded-sm border border-[#B68A35]/30 bg-[#F7F4EE] flex items-center justify-center mb-6 group-hover:bg-[#0E2238] group-hover:border-[#0E2238] transition-all duration-500">
                    <Icon className="w-5 h-5 text-[#B68A35] group-hover:text-[#D6B36A] transition-colors" strokeWidth={1.5} />
                  </div>
                  <h3 className="font-serif text-[#0E2238] text-2xl md:text-[1.65rem] mb-4 tracking-tight leading-tight">
                    {s.title}
                  </h3>
                  <p className="text-[#2B2B2B]/75 text-[0.95rem] leading-[1.7] font-light flex-1">
                    {s.copy}
                  </p>
                  <div className="mt-6 h-px w-8 bg-[#B68A35] group-hover:w-24 transition-all duration-[700ms] ease-out" />
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
